import React from 'react';

import Col from 'ui-library/bs/Col';

interface PrimerRowHeaderProps {
  inputs: Array<string>;
}

function PrimerRowHeader(props: PrimerRowHeaderProps): JSX.Element {
  return (
    <div>
      {Array.from(props.inputs).map((label, key) => (
        <Col md={3} className="text-center" key={key}>
          {label}
        </Col>
      ))}
    </div>
  );
}

export default PrimerRowHeader;
